import { observer } from 'mobx-react-lite'
import { Typography, Scrollbar } from 'shared/ui'
import { DayjsFormats } from 'shared/lib'
import { uiStore } from 'shared/store/uiStore'
import { MessageCard } from 'widgets/MessageCard'
import { type CreditUsageMessageModalStore } from '../store/creditUsageMessageModalStore'
import styles from './styles.module.scss'

type ICreditUsageMessageModalContentProps = {
  store: CreditUsageMessageModalStore
}

export const CreditUsageMessageModalContent = observer(
  ({ store }: ICreditUsageMessageModalContentProps) => {
    const { message, creditUsage } = store

    return (
      <div className={styles.wrapper}>
        <Scrollbar
          className={styles.scrollbar}
          viewClassName={styles.scrollbar__view}
          autoHeight
          autoHeightMin={0}
          autoHeightMax={'100%'}
          height={'100%'}
        >
          <div className={styles.scrollbar__content}>
            <Typography
              className={styles.date}
              variant={'body-sm-regular'}
              ariaLabel={'MessageDate'}
            >
              {uiStore.dayjs(creditUsage.processed_at).format(DayjsFormats.full5)}
            </Typography>
            <MessageCard
              message={message}
              isLast={true}
              hideTeam={false}
              conversationMessagesStore={null}
              callContentStore={undefined}
            />
          </div>
        </Scrollbar>
      </div>
    )
  }
)
